import { Routes } from '@angular/router';
import { authGuard } from '../guards/auth.guard';
import { clientIdGuard } from '../guards/client-id/client-id.guard';
import { isPartnerGuard } from '../guards/isPartner/is-partner.guard';

export const currentUserPagesRoutes: Routes = [
  {
    path: 'user-profile',
    loadComponent: () =>
      import('../components/user-profile/user-profile.component').then(
        (m) => m.UserProfileComponent
      ),
    canActivate: [authGuard, clientIdGuard, isPartnerGuard],
  },
];
